<div class="badge-wrapper" [class.center]="center">
  <app-badge [type]="type" [icon]="this.icon" [size]="this.size"/>
  @if (header) {
    <div class="title">{{ header }}</div>
  }
  <div class="content">
    {{ content }}
    <ng-content></ng-content>
  </div>
</div>
